import { render, staticRenderFns } from "./baseCar.vue?vue&type=template&id=073505fa&"
import script from "./baseCar.vue?vue&type=script&lang=js&"
export * from "./baseCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports